export const MOBILE_S = '(min-width: 320px)'
export const MOBILE_M = '(min-width: 375px)'
export const MOBILE_L = '(min-width: 425px)'
export const TABLET = '(min-width: 768px)'
export const LAPTOP = '(min-width: 1024px)'
export const LAPTOP_L = '(min-width: 1440px)'
export const DESKTOP = '(min-width: 2560px)'
